import { FieldDefinition } from '../../../../component/form/field-definition';
import { SelectItem } from '../../../../component/form/select-item';
import { answerTypes, getAnswerTypeName } from '../../enum/survey-answer-type';

const answerTypeOptions = () => {
    return answerTypes.map(_ => {
        let selectItem: SelectItem = {
            id: _,
            name: getAnswerTypeName(_)
        }
        return selectItem;
    });
}

export const surveyQuestionFieldDefinitions: FieldDefinition[] = [
    {
        id: "title",
        name: "Question",
        type: "text",
        required: true,
        disabled: false,
    },
    {
        id: "answerType",
        name: "Answer type",
        type: "select",
        required: true,
        disabled: false,
        values: answerTypeOptions()
    },
    {
        id: "answerRequired",
        name: "Answer required",
        type: "boolean",
        required: true,
        disabled: false
    }
];